import { PulseBaseProvider } from '../../base-classes';

const _getComplianceInfoCacheKey = 'getComplianceInfo';
const _getComplianceInfoUri = '/api/legal/compliance/v2';

export class ComplianceInfoProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_getComplianceInfoCacheKey] = this.getComplianceInfoSyncer.bind(this);
    }

    async getComplianceInfoSyncer(params) {
        const {
            id,
            syncParams,
            resolve,
            reject
        } = params;
        
        const queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose,
            LocationType: syncParams.LocationType,
            Location: syncParams.Location
        };
        
        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getComplianceInfoUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getComplianceInfo(stdParameters, verbose = false, refresh = false, LocationType, Location) {
        const syncParams = {
            verbose: !!verbose,
            refresh,
            LocationType,
            Location
        };

        const id = JSON.stringify(syncParams);
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getComplianceInfoCacheKey, id);
        }
        return await super.loadFromStorage(_getComplianceInfoCacheKey, id, syncParams);
    }
}